// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"a281d7d1","269":"212ef6a5","339":"5de909ca","453":"0994e662","617":"2a99888b","640":"cc676909","726":"9d8db811"}[chunkId] + ".chunk.js";
};